export default __webpack_public_path__ + "static/media/pag13.b2875474.jpg";